import styles from './styles.module.css';

export default function Cortana() {
  return (
    <div className={styles.cortana}>
      <div className={styles.outer}>
        <div className={styles.inner}></div>
      </div>
    </div>
  )
}
